import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class RouteGuard implements CanActivate {

  constructor(
    private messageService: MessageService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const matchedRoutesString = sessionStorage.getItem('matchedRoutes') as string;
    const matchedRoutes: any[] = matchedRoutesString ? JSON.parse(matchedRoutesString) : [];

    var routerPath = '';
    var result = false;

    if (matchedRoutes.length !== 0) {
      for (let i = 0; i < route.url.length; i++) {
        routerPath = routerPath + route.url[i].path + '/';
      }
      routerPath = routerPath.slice(0, -1);
      result = matchedRoutes.some(item => item.includes(routerPath));
    }

    if (result) {
      return true;
    } else {
      this.messageService.add({ severity: 'error', summary: 'Unauthorized!', detail: 'You are not authorized to access this page!' });
      this.router.navigate(['/']);
      return false;
    }
  }
}